export const heroArticle = {
  id: 'hero-001',
  title: '顶流网红直播间翻车实录：私下言论曝光引发全网震动',
  summary: '拥有千万粉丝的知名网红在直播中被意外曝光私下不当言论，相关录音在社交媒体疯传，品牌方火速解约，粉丝群体分裂成两派，事件持续发酵中。',
  tag: '独家爆料',
  image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20darkened%20studio%20scene%20with%20a%20broken%20smartphone%20screen%20on%20a%20dark%20wooden%20table%2C%20surrounded%20by%20scattered%20microphone%20and%20headphones%2C%20warm%20amber%20spotlight%20creating%20mysterious%20atmosphere%2C%20cinematic%20lighting%20with%20deep%20shadows%2C%20editorial%20photography%20style%2C%20dramatic%20composition%2C%20dark%20moody%20background%20with%20gossip%20magazine%20aesthetic&width=1600&height=900&seq=hero-gossip-01&orientation=landscape',
  date: '2026-07-06',
  author: '吃瓜小编',
};

export const latestArticles = [
  {
    id: 'article-001',
    title: '知名男星深夜密会神秘女子，酒店同框照流出',
    summary: '被拍到与一位神秘女子深夜同进酒店，次日早晨才分别离开，引发婚变猜测。',
    tag: '实锤',
    tagColor: 'bg-primary-500',
    image: 'https://readdy.ai/api/search-image?query=A%20blurry%20paparazzi%20style%20night%20shot%20of%20a%20luxury%20hotel%20entrance%20with%20warm%20golden%20lights%2C%20silhouette%20figures%20in%20the%20distance%2C%20dramatic%20moody%20night%20atmosphere%2C%20dark%20ambient%20lighting%2C%20tabloid%20magazine%20photography%20style%2C%20mysterious%20vibe&width=800&height=600&seq=article-gossip-01&orientation=landscape',
    category: '明星黑料',
    date: '2026-07-06',
  },
  {
    id: 'article-002',
    title: '美妆博主被爆虚假宣传，粉丝实测产品效果天差地别',
    summary: '多位粉丝晒出实测对比图，揭露某带货美妆博主夸大产品功效，评论区已沦陷。',
    tag: '热议',
    tagColor: 'bg-accent-500',
    image: 'https://readdy.ai/api/search-image?query=A%20messy%20vanity%20desk%20with%20scattered%20cosmetics%20and%20broken%20mirror%2C%20half%20opened%20lipstick%20and%20foundation%20bottles%2C%20dramatic%20side%20lighting%20creating%20harsh%20shadows%2C%20beauty%20scandal%20concept%2C%20editorial%20photography%20with%20warm%20neutral%20background%2C%20cinematic%20composition&width=800&height=600&seq=article-gossip-02&orientation=landscape',
    category: '博主反差',
    date: '2026-07-05',
  },
  {
    id: 'article-003',
    title: '某女团成员被曝队内霸凌，聊天记录截图全网疯传',
    summary: '疑似内部工作人员爆料，公开多张聊天截图显示队内存在长期霸凌行为，经纪公司紧急公关。',
    tag: '独家',
    tagColor: 'bg-primary-500',
    image: 'https://readdy.ai/api/search-image?query=A%20smartphone%20displaying%20chat%20messages%20on%20a%20dark%20surface%2C%20dramatic%20shadow%20play%2C%20tense%20atmosphere%2C%20warm%20amber%20light%20from%20the%20screen%20illuminating%20the%20dark%20background%2C%20mysterious%20vibe%2C%20editorial%20photography%20style%2C%20gossip%20magazine%20aesthetic&width=800&height=600&seq=article-gossip-03&orientation=landscape',
    category: '明星黑料',
    date: '2026-07-05',
  },
  {
    id: 'article-004',
    title: '千万粉游戏主播代打实锤，直播时意外露出代练软件界面',
    summary: '知名游戏主播直播时不慎切换窗口，露出第三方代打软件界面，观众录屏证据确凿。',
    tag: '实锤',
    tagColor: 'bg-primary-500',
    image: 'https://readdy.ai/api/search-image?query=A%20gaming%20setup%20with%20multiple%20monitors%20in%20a%20dark%20room%2C%20one%20screen%20showing%20suspicious%20software%20interface%2C%20dramatic%20neon%20RGB%20lighting%2C%20tense%20gaming%20atmosphere%2C%20esports%20streamer%20scandal%20concept%2C%20cinematic%20composition%20with%20deep%20shadows&width=800&height=600&seq=article-gossip-04&orientation=landscape',
    category: '网红塌房',
    date: '2026-07-04',
  },
  {
    id: 'article-005',
    title: '知名情侣博主分手内幕：出轨证据被对方助理曝光',
    summary: '曾被誉为模范情侣的知名博主突然宣布分手，疑似第三者插足，助理发文暗示有隐情。',
    tag: '热议',
    tagColor: 'bg-accent-500',
    image: 'https://readdy.ai/api/search-image?query=A%20torn%20polaroid%20photo%20of%20a%20couple%20on%20a%20dark%20wooden%20table%2C%20dramatic%20shadow%20and%20warm%20light%2C%20emotional%20breakup%20concept%2C%20editorial%20photography%20with%20moody%20atmosphere%2C%20heartbreak%20aesthetic%2C%20soft%20amber%20lighting&width=800&height=600&seq=article-gossip-05&orientation=landscape',
    category: '网红塌房',
    date: '2026-07-04',
  },
  {
    id: 'article-006',
    title: '选秀冠军学历造假风波，母校回应称查无此人的就读记录',
    summary: '网友深挖发现其自称的海外名校学历疑似伪造，校方回应声明引发更大争议。',
    tag: '独家',
    tagColor: 'bg-primary-500',
    image: 'https://readdy.ai/api/search-image?query=A%20fake%20diploma%20certificate%20with%20a%20magnifying%20glass%20on%20top%20showing%20suspicious%20details%2C%20dark%20wooden%20desk%20surface%2C%20dramatic%20overhead%20lighting%2C%20investigative%20journalism%20concept%2C%20warm%20moody%20atmosphere%2C%20editorial%20photography&width=800&height=600&seq=article-gossip-06&orientation=landscape',
    category: '明星黑料',
    date: '2026-07-03',
  },
  {
    id: 'article-007',
    title: '美食博主后厨卫生堪忧，前员工匿名投稿曝光脏乱真相',
    summary: '一位自称曾在该博主工作室工作的匿名人士发布多张后厨照片，引发食品安全担忧。',
    tag: '热议',
    tagColor: 'bg-accent-500',
    image: 'https://readdy.ai/api/search-image?query=A%20messy%20dirty%20kitchen%20counter%20with%20scattered%20food%20waste%20and%20unclean%20utensils%2C%20dramatic%20harsh%20lighting%20from%20a%20single%20overhead%20bulb%2C%20dark%20corners%2C%20food%20safety%20scandal%20concept%2C%20documentary%20photography%20style%2C%20grimy%20atmosphere&width=800&height=600&seq=article-gossip-07&orientation=landscape',
    category: '博主反差',
    date: '2026-07-03',
  },
  {
    id: 'article-008',
    title: '知名rapper被前女友爆料家暴，医院验伤报告流出',
    summary: '前女友在社交平台发布长文控诉，附带医院验伤报告和聊天记录，事件迅速登顶热搜。',
    tag: '实锤',
    tagColor: 'bg-primary-500',
    image: 'https://readdy.ai/api/search-image?query=A%20cracked%20smartphone%20screen%20on%20a%20dark%20floor%20with%20dramatic%20side%20lighting%2C%20medical%20report%20papers%20scattered%20nearby%2C%20tense%20domestic%20violence%20awareness%20concept%2C%20moody%20atmosphere%20with%20deep%20shadows%2C%20editorial%20photography%20style&width=800&height=600&seq=article-gossip-08&orientation=landscape',
    category: '明星黑料',
    date: '2026-07-02',
  },
];

export const categories = [
  {
    slug: 'mingxing-heiliao',
    name: '明星黑料',
    description: '娱乐圈明星不为人知的秘密，从顶流到十八线，只有你想不到，没有我们挖不到的黑料。',
    icon: 'ri-star-line',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20backstage%20scene%20with%20a%20single%20spotlight%20on%20an%20empty%20stage%2C%20velvet%20curtains%20in%20deep%20red%2C%20mysterious%20atmosphere%2C%20theater%20dressing%20room%20concept%2C%20warm%20dramatic%20lighting%2C%20editorial%20photography%2C%20cinematic%20composition&width=600&height=400&seq=category-star-scandal&orientation=landscape',
    count: 128,
  },
  {
    slug: 'wanghong-tafang',
    name: '网红塌房',
    description: '短视频网红、带货主播、游戏主播的翻车现场全记录，塌房速度比翻书还快，我们第一时间跟进。',
    icon: 'ri-collapse-diagonal-line',
    image: 'https://readdy.ai/api/search-image?query=A%20collapsing%20house%20of%20cards%20made%20of%20social%20media%20icons%20on%20a%20dark%20surface%2C%20dramatic%20warm%20lighting%2C%20symbolic%20concept%20of%20reputation%20collapse%2C%20editorial%20photography%20style%2C%20moody%20atmosphere%2C%20deep%20shadows&width=600&height=400&seq=category-influencer-fall&orientation=landscape',
    count: 96,
  },
  {
    slug: 'bozhu-fancha',
    name: '博主反差',
    description: '人前光鲜亮丽、人设完美的博主背后，反差巨大的真实生活曝光，人设崩塌只在一瞬间。',
    icon: 'ri-contrast-2-line',
    image: 'https://readdy.ai/api/search-image?query=A%20split%20face%20mask%20half%20beautiful%20half%20cracked%20on%20a%20dark%20velvet%20surface%2C%20dramatic%20chiaroscuro%20lighting%2C%20duality%20concept%2C%20warm%20and%20cool%20tone%20contrast%2C%20editorial%20photography%2C%20symbolic%20atmosphere&width=600&height=400&seq=category-blogger-contrast&orientation=landscape',
    count: 87,
  },
];

export const userReviews = [
  {
    quote: '在这个信息爆炸的时代，吃瓜网是我每天必刷的网站。爆料速度快、内容真实度高，很多事件在其他平台还没反应过来时这里就已经有详细复盘了。',
    author: '资深吃瓜群众',
    badge: '铁粉认证',
    image: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20person%20profile%20side%20view%20black%20and%20white%20portrait%2C%20contemplative%20expression%2C%20looking%20slightly%20upward%2C%20clean%20white%20background%2C%20fine%20art%20portrait%20photography%2C%20soft%20dramatic%20lighting%2C%20shoulders%20up%20composition&width=600&height=800&seq=review-user-01&orientation=portrait',
  },
  {
    quote: '吃瓜网的爆料内容从不让我失望，每次有大事件发生我第一个打开的就是这里。编辑团队很专业，整理的时间线和证据链清晰明了。',
    author: '娱乐八卦达人',
    badge: '活跃用户',
    image: 'https://readdy.ai/api/search-image?query=A%20Chinese%20woman%20profile%20side%20view%20black%20and%20white%20portrait%2C%20confident%20expression%2C%20gazing%20upward%2C%20pure%20white%20background%2C%20fine%20art%20portrait%20style%2C%20elegant%20composition%2C%20soft%20lighting%20with%20gentle%20shadows&width=600&height=800&seq=review-user-02&orientation=portrait',
  },
  {
    quote: '自从关注了吃瓜网，我成了朋友圈里的消息灵通人士。这里的瓜又大又甜，关键是更新快，经常是全网首发，强烈推荐给所有爱吃瓜的朋友。',
    author: '网络冲浪选手',
    badge: '新锐读者',
    image: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20man%20profile%20side%20view%20black%20and%20white%20portrait%2C%20thoughtful%20expression%20looking%20upward%2C%20clean%20white%20background%2C%20fine%20art%20portrait%20photography%2C%20soft%20dramatic%20lighting%2C%20shoulders%20up%20composition&width=600&height=800&seq=review-user-03&orientation=portrait',
  },
];

export const homepageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '吃瓜网官网',
  alternateName: '51吃瓜网官网 · 91吃瓜网官网 · 黑料吃瓜网官网',
  url: 'https://www.chiguawang.com',
  description: '吃瓜网官网首页入口，提供51吃瓜网官网、91吃瓜网官网、黑料吃瓜网官网等最新热门吃瓜爆料内容。每日更新网红塌房、明星黑料、博主反差视频等网络热门事件。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.chiguawang.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
  inLanguage: 'zh-CN',
};